import * as React from 'react'

interface ReviewContextType {
  reviewId: string | null
}

const ReviewContext = React.createContext<ReviewContextType | undefined>(undefined)

export const ReviewProvider: React.FC<{ children: React.ReactNode; reviewId: string }> = ({
  children,
  reviewId,
}) => {
  const reviewContextValue: ReviewContextType = {
    reviewId,
  }

  return <ReviewContext.Provider value={reviewContextValue}>{children}</ReviewContext.Provider>
}

export const useReviewContext = () => {
  const context = React.useContext(ReviewContext)
  if (context === undefined) {
    throw new Error('useReviewContext must be used within a ReviewProvider')
  }
  return context
}

export const useReviewId = () => {
  const context = useReviewContext()
  return context.reviewId
}
